export default theme => ({
  productName: {
    marginTop: theme.spacing(1),
  },
  productDesc: {
    margin: 0,
  },
});